import React, { useState, useRef } from 'react';
import { Camera, User } from 'lucide-react';

interface AvatarUploadProps {
  label?: string;
  onChange?: (file: File) => void;
  previewUrl?: string;
}

export function AvatarUpload({ label, onChange, previewUrl }: AvatarUploadProps) {
  const [preview, setPreview] = useState<string | null>(previewUrl || null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setPreview(url);
      if (onChange) onChange(file);
    }
  };

  return (
    <div className="flex flex-col gap-2 items-center sm:items-start">
      {label && <label className="text-sm font-medium text-gray-900">{label}</label>}
      <div 
        onClick={() => fileInputRef.current?.click()}
        className="relative group w-24 h-24 rounded-full border-2 border-dashed border-gray-300 bg-gray-50 flex items-center justify-center cursor-pointer overflow-hidden transition-all hover:border-indigo-500"
      >
        {preview ? (
          <img src={preview} alt="Avatar" className="w-full h-full object-cover" />
        ) : (
          <User size={32} className="text-gray-400 group-hover:text-indigo-500 transition-colors" />
        )}
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <Camera size={20} className="text-white" />
        </div>
      </div>
      <input 
        ref={fileInputRef}
        type="file" 
        accept="image/*" 
        className="hidden" 
        onChange={handleFileChange} 
      />
    </div>
  );
}
